
import $ from "jquery";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Link } from 'react-router-dom';
import React,{useState,useContext,useEffect} from 'react'
import { ManagerAuthContext } from "../context/AuthManager";
import axios from 'axios';

export const Dashboard = () => {

    const { currentUserRF } = useContext(ManagerAuthContext);

  const closeSide = () =>{
    $("#mobileMenuOpen").click(function () {
        $("#mobileMenu").addClass("open");
        $("#adjusmentLayer").addClass("show");
    });
}

const [showb, setShowb] = useState(false);
const handleCloseb = () => setShowb(false);
const handleShowb = () => setShowb(true);

const showPopup = () =>{
    handleShowb(true)
}

if (currentUserRF.meli === null) {
   } else {
  return (
    <>  
    <aside class="sidebar h-100 position-relative d-none d-md-block" dir='rtl'>
        <img src="../img/sidebar-auth-cover.png"
            class="position-absolute right-0 left-0 m-auto top-0 w-100 d-none d-xl-block" alt="" />
        <div class="auth-box-container m-auto d-none d-xl-block">
            <div class="auth-img-container">
                <img src={currentUserRF.img} alt="" class="avatar" />
            </div>
            <p class="text-center auth-name d-none d-xl-block">پزشک : {currentUserRF.name}</p>
            <p class="text-center auth-number d-none d-xl-block">کد ملی : {currentUserRF.meli}</p>
            <p class="text-center auth-number d-none d-xl-block">کد نظام : {currentUserRF.nezam}</p>
            <Link to="/AdminLogin"><button
                class="custom-btn-primary power-button m-auto position-relative overflow-hidden h-auto d-flex justify-content-center align-items-center">
               <i class="zmdi zmdi-power text-white"></i>
                <div class="reple position-absolute"></div>
            </button></Link>
        </div>
        <ul class="d-flex flex-column main-menu p-0">
            <img src="../img/Avatar-Image.png" alt="" width="58"
                class="d-block d-xl-none m-auto text-center mb-4 rounded-circle" />
            <li class="d-flex flex-column align-items-center justify-content-between w-100 color-primary">
                <Link to="/AdminPanel/ViewPanel" class="menu-active position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw text-primary"></i>
                        <p class="my-0 mx-3 d-none d-xl-block text-primary">داشبورد</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 color-primary">
                <Link to="/AdminPanel/AdminConsultant" class="menu-active position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 d-none d-xl-block text-default">بیماران</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 color-primary">
                <Link to="/AdminPanel/accountOnline" class="menu-active position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 d-none d-xl-block text-default">نوبت آنلاین</p>
                    </div>
                </Link>
            </li>

            <li class="d-flex align-items-center justify-content-between w-100 color-primary">
                <Link to="/AdminPanel/serviceCardex" class="menu-active position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 d-none d-xl-block text-default">سرویس ها</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 color-primary">
                <Link to="/AdminPanel/diagnos" class="menu-active position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 d-none d-xl-block text-default">تشخیص</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 color-primary">
                <Link to="/AdminPanel/AccountReport" class="menu-active position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 d-none d-xl-block text-default">حسابداری</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 color-primary">
                <Link to="/AdminPanel/folder" class="menu-active position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 d-none d-xl-block text-default">پروندهای قدیم</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 color-primary">
            {/* /AdminPanel/SicknessPeriod */}
                <Link to="/AdminPanel/allreport" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw text-default"></i>
                        <p class="my-0 mx-3 d-none d-xl-block text-default">گزارش-صورتحساب</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100">
                <Link to="" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw text-default"></i>
                        <p class="my-0 mx-3 text-default d-none d-xl-block">تغییر رمز</p>
                    </div>
                </Link>
            </li>
        </ul>
    </aside>
    <aside class="mobile-sidebar" id="mobileMenu" dir='rtl'>
        <ul class="d-flex flex-column main-menu-responsive p-0">
            <div class="d-flex flex-column justify-content-between align-items-center">
                <img src="../img/logo.png" width="140" alt="" />
            </div>
            <div class="devider"></div>
            <li class="d-flex align-items-center justify-content-between w-100 menu-item">
                <Link to="/AdminPanel/ViewPanel" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-home text-primary"></i>
                        <p class="my-0 mx-3 text-default text-primary">داشبورد</p>
                    </div>
                </Link>
            </li>

            <li class="d-flex align-items-center justify-content-between w-100 menu-item">
                <Link to="/AdminPanel/UsersList" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 text-default">کاربران</p>
                    </div>
                </Link>
            </li>

            <li class="d-flex align-items-center justify-content-between w-100 menu-item">
                <Link to="/AdminPanel/AdminConsultant" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 text-default">مشاوران</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 menu-item">
                <Link to="/AdminPanel/MedicalComman" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 text-default">دستورات پزشکی</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 menu-item">
                <Link to="/AdminPanel/Cardex" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 text-default">کاردکس دارویی</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 menu-item">
                <Link to="/AdminPanel/SummeryDoc" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 text-default">خلاصه پرونده</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 menu-item">
                <Link to="/AdminPanel/Memoir" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 text-default">شرح حال</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 menu-item">
                <Link to="/AdminPanel/SicknessPeriod" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw text-default"></i>
                        <p class="my-0 mx-3 text-default">سیر بیماری</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 menu-item">
                <Link to="" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw text-default"></i>
                        <p class="my-0 mx-3 text-default">تیکت پشتیبانی</p>
                    </div>
                </Link>
            </li>
        </ul>
    </aside>
    
    <div class="d-flex flex-column w-100" dir='rtl'>
      
        <div class="block-header d-flex d-md-none flex-row-reverse">
            <div class="d-flex justify-content-center align-items-center flex-row-reverse">
                <img src="../img/Avatar-Image.png" class="block-header-auth-img rounded-circle" alt="" />
                <button class="btn btn-icon mobile_menu mx-3" type="button"> <i
                        class="zmdi zmdi-settings mx-3"></i></button>
                <button class="btn btn-icon mobile_menu" type="button"> <i class="zmdi zmdi-power"></i></button>
            </div>
            <button class="btn btn-icon mobile_menu custom-bg-primary" type="button" onClick={closeSide} id="mobileMenuOpen"><i
                    class="zmdi zmdi-sort-amount-desc"></i></button>
        </div>
        <div class="d-none d-md-flex w-100">
            <div class="app-header-bar p-24 w-100">
                <div class="d-flex align-items-center justify-content-between">
                    <div class="w-50 d-flex justify-content-start align-items-center w-auto">
                        <button
                            class="custom-btn-primary ml-16 app-header-botton-control position-relative w-auto px-1">
                            <span> دریافت
                                گزارش
                                کاربری</span>
                            <span class="app-header-botton-devider mx-2"></span>
                            <div href="#" class="app-header-botton-control-link">
                                <img src="../icons/exists icon arrow.svg" alt="" />
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
   </>
  )
}
}
